import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { EFilters } from 'features/Filters';
import { useGetAppConfigQuery } from 'shared/api';
import { EStatuses } from 'shared/typings';

export const useSetLocalStorageFilters = () => {
	const { data: appConfig } = useGetAppConfigQuery();
	const [searchParams, setSearchParams] = useSearchParams();
	const { pathname } = useLocation();

	useEffect(() => {
		const filters = JSON.parse(localStorage.getItem(`filters_${appConfig?.user?.user_id}`) || '{}');
		if (
			(!searchParams.toString() ||
				(searchParams.size === 1 && searchParams.get(EFilters.STATUS) === EStatuses.JOINED)) &&
			filters[pathname]
		) {
			setSearchParams(filters[pathname]);
		}
	}, [pathname, appConfig?.user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps
};
